import React, { useState } from "react";
import {
  FaDesktop,
  FaMobileAlt,
  FaAndroid,
  FaListAlt,
  FaUserTie,
  FaShoppingCart,
  FaGlobe,
} from "react-icons/fa";
import invoice_img from "../../../assets/Docs/invoices.png";
import invoice_app from '../../../assets/AppImages/invoice.png'

import { TagComponent } from "../Tabs";

const ItemisedQuantityReport = () => {
  const [activeTab2, setActiveTab2] = useState("web");
  const tabs = [
    { id: "web", label: "Web App", icon: <FaDesktop /> },
    {
      id: "mobile",
      label: "Mobile App",
      icon: <FaMobileAlt />,
      disabled: true,
    },
  ];

  const renderTabs = (activeState, setActiveState) => (
    <div className="flex flex-col sm:flex-row gap-2 border-b border-[#b9ece6] sm:gap-4 mb-6">
      {tabs.map((tab) => (
        <button
          key={tab.id}
          onClick={() => setActiveState(tab.id)}
          className={`flex items-center justify-center sm:justify-start gap-2 px-4 py-2 rounded-t-md transition-all text-sm w-full sm:w-auto ${activeState === tab.id
            ? "bg-[#1a9588] text-white shadow"
            : "bg-[#dbf4f1] text-gray-700 hover:bg-[#b9ece6]"
            }`}

        >
          {tab.icon}
          {tab.label}
        </button>
      ))}
    </div>
  );


  return (
    <div className="bg-white shadow-lg rounded-xl p-6 sm:p-8  mx-auto border border-gray-200" id="top">

      <div className="flex items-center mb-6 border-b pb-4 border-gray-200">
        <FaListAlt className="text-4xl text-theme-logo-color mr-3" />
        <h1 className="text-2xl sm:text-3xl font-bold text-theme-logo-color">Order Invoice</h1>
      </div>

      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-8 gap-4">
        <div className="flex flex-wrap gap-3">
          <TagComponent icon={<FaUserTie />} label="Seller" color="pink" />
          <TagComponent icon={<FaShoppingCart />} label="Buyer" color="green" />
        </div>
        <div className="flex flex-wrap gap-3">
          <TagComponent icon={<FaGlobe />} label="Web" color="green" />
          <TagComponent icon={<FaAndroid />} label="Android" color="green" />
        </div>
      </div>


      {/* Intro Text */}
      <div className="bg-gray-50 p-6 rounded-2xl ">
        <p className="text-gray-700 text-start text-base leading-relaxed ">
          An Itemised Quantity Report can be created for the selected orders,
          providing the total quantity needed per product and size to fulfill
          them.
        </p>
      </div>
      <div className="">
        {renderTabs(activeTab2, setActiveTab2)}
        <div className="rounded-xl p-4 sm:p-6  bg-gray-50 border border-gray-200 shadow-sm hover:shadow-md transition">
          <p className="mt-6 text-gray-500 text-sm ">
            Items in the Adjustment Cart are shown along with their Order#. Both
            the 'Buyer' and the 'Supplier' can transfer these items from the
            Adjustment Cart to the active Order Cart.
          </p>

          {activeTab2 === "web" ? (
            <img
              src={invoice_img}
              alt={`view`}
              className="rounded-xl max-w-full h-auto object-contain"
            />
          ) : (
            <img
              src={invoice_app}
              alt={`view`}
              className="rounded-xl max-w-full h-auto object-contain"
            />
          )}

        </div>
      </div>
    </div>
  );
};

export default ItemisedQuantityReport;
